module.exports = __webpack_public_path__ + "static/media/confirm.749e75ae.png";